import { flow, map, sortBy, uniqBy } from 'lodash/fp';

import { isDraftId, removeDraftPrefix } from '../sanity-draft';
import { Maybe } from '../../../types/__codegen__/sanity/graphql';

type ItemWithId = {
  id?: string | Maybe<string>;
  _id?: string | Maybe<string>;
};

export type DeclaresIdKey<T> = 'id' extends keyof T ? T : '_id' extends keyof T ? T : never;

const uniqueContentWithDraftPrecedence = <T extends ItemWithId>(items: DeclaresIdKey<T>[] | null | undefined) =>
  flow(
    sortBy((item: T) => !isDraftId(item.id || item._id)),
    map((item) => {
      const idKey = item.id ? 'id' : '_id';
      return {
        ...item,
        [idKey]: removeDraftPrefix(item[idKey]),
      };
    }),
    uniqBy((item) => item.id || item._id),
  )(items);

export default uniqueContentWithDraftPrecedence;
